<script setup lang="ts">
import { type ProductDetails, ShippingType } from "mws-ts-v2-sdk";

type Props = {
  product: ProductDetails;
};
const { product } = defineProps<Props>();

const shippingSponsor = computed(() => {
  if (product.beneficiary?.name === "Ahbap For Turkey") {
    // special case for the Turkish Earthquake fundraiser
    return {
      name: "DHL Express",
      link: "https://bit.ly/3KsDMEN",
    };
  }

  return null;
});

const isFinished = computed(() => product.finished);

const { data: bidCosts } = useBidCosts({
  product: () => product,
  enabled: isFinished,
});
</script>

<template>
  <ClientOnly>
    <template #fallback>
      <BaseSkeletonLoader
        :height="60"
        width="100%"
      />
    </template>
    <ProductSidebarUSP icon-key="truck">
      <template #title>
        {{
          product.shippingType === ShippingType.FreeShipping
            ? $t("bidProductSidebar.shipping.freeShippingTitle")
            : $t("bidProductSidebar.shipping.defaultShippingTitle")
        }}
      </template>

      <template #description>
        <div data-test="shipping-text-shipping-costs">
          <ProductShippingDetails
            v-if="!isFinished"
            :product="product"
            :is-sidebar-details="true"
          />
          <div v-else>
            <span class="pr-1">
              {{ $t("bidProductSidebar.shipping.description") }}
            </span>
            <I18nT
              v-if="product.shippingType === ShippingType.FreeShipping"
              scope="global"
              tag="span"
              :keypath="
                shippingSponsor
                  ? 'product.sponsoredShipping'
                  : 'product.shipping'
              "
            >
              <template #sponsorName>
                <component
                  :is="shippingSponsor?.link ? 'a' : 'span'"
                  :href="shippingSponsor?.link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ shippingSponsor?.name }}
                </component>
              </template>
            </I18nT>

            <span
              v-else-if="product.shippingType === ShippingType.PaidShipping"
            >
              <I18nT
                v-if="bidCosts"
                scope="global"
                keypath="product.sidebarShippingOffice"
                tag="span"
                class="pr-0.5"
              >
                <template #PLACEHOLDER_officeName>
                  {{ bidCosts.shippingOfficeName }}
                </template>
              </I18nT>
            </span>
          </div>
        </div>
      </template>
    </ProductSidebarUSP>
  </ClientOnly>
</template>
